import React, { useEffect, useState } from 'react'
import ApexCharts from 'react-apexcharts'
import moment from 'moment'
import { Card, CardBody, CardHeader } from 'reactstrap'

const initialConfig = {
  series: '',
  options: {
    chart: { height: 350, type: 'bar' },
    plotOptions: {
      bar: {
        borderRadius: 10,
        dataLabels: { position: 'top' },
      },
    },
    colors: ['#0274be'],
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val
      },
      offsetY: -25,
      style: { fontSize: '12px', colors: ['#304758'] },
    },
    xaxis: {
      categories: {},
      position: 'bottom',
      axisBorder: { show: false },
      axisTicks: { show: false },
      crosshairs: {
        fill: {
          type: 'gradient',
          gradient: {
            colorFrom: '#D8E3F0',
            colorTo: '#BED1E6',
            stops: [0, 100],
            opacityFrom: 0.4,
            opacityTo: 0.5,
          },
        },
      },
      tooltip: { enabled: false },
    },
    yaxis: {
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: {
        show: true,
        formatter: function (val) {
          return val
        },
      },
    },
  },
}
export default function ObjChart({ dataGrid }) {
  const [config, setConfig] = useState()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (isLoading == true) {
      let series = []
      let dtAnt = ''

      for (let item of dataGrid) {
        if (dtAnt != moment(item.dhCadastro).format('DD/MM')) {
          series.push({ data: moment(item.dhCadastro).format('DD/MM'), qtde: 0 })
        }

        series[series.length - 1].qtde++

        dtAnt = moment(item.dhCadastro).format('DD/MM')
      }

      series.sort((a, b) => (new Date(a.data + '/2020') > new Date(b.data + '/2020') ? 1 : -1))

      let _config = { ...initialConfig }
      _config.series = [{ name: 'Interações', data: series.map((d) => d.qtde) }]
      _config.options.xaxis.categories = series.map((d) => d.data)
      setConfig(_config)

      setIsLoading(false)
    }
  }, [isLoading])

  useEffect(() => {
    setConfig(initialConfig)
    setIsLoading(true)
  }, [dataGrid])

  return (
    <Card className="main-card mb-2">
      <CardHeader>Interações por dia</CardHeader>
      {config?.series && (
        <CardBody style={{ textAlign: 'center' }}>
          <ApexCharts options={config.options} series={config.series} type="bar" height={346} />
        </CardBody>
      )}
    </Card>
  )
}
